var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24 46.9266C11.338 46.9266 1.07336 36.662 1.07336 24C1.07336 11.338 11.338 1.07337 24 1.07337C36.662 1.07337 46.9266 11.338 46.9266 24C46.9266 36.662 36.662 46.9266 24 46.9266Z","stroke":"#333333","strokeWidth":"1.41111","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M29.9667 25.0292H26.3468V36.6779H20.9804V25.0292H18.4285V20.469H20.9804V17.5178C20.9804 15.4081 21.983 12.1032 26.3945 12.1032L30.3692 12.1203V16.5464H27.4851C27.0122 16.5464 26.3468 16.783 26.3468 17.7893V20.4733H30.4352L29.9667 25.0292Z","fill":"#333333","key":1})]);
}

Facebook.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
